module.exports = __webpack_public_path__ + "img/c5.2beeda11.svg";